/*
  Perception (Lovable) behaviour for pl-* sections. Plain JavaScript, loaded with defer.
  Trade's own JS still handles the cart, variants and filters.
*/
(function () {
  'use strict';

  var CHOICE_KEY = 'pl-choice';
  var EMAIL_KEY = 'pl-waitlist-email';

  function store(method, key, value) {
    try {
      return method === 'get' ? JSON.parse(sessionStorage.getItem(key) || 'null') : sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      return null;
    }
  }

  function setText(root, field, value) {
    root.querySelectorAll('[data-pl-field="' + field + '"]').forEach(function (el) {
      el.textContent = value;
    });
  }

  // Featured coffee carousel (pl-hero)
  function initFeatured(root) {
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-pl-tile]'));
    if (!tiles.length) return;
    var current = 0;
    var title = root.querySelector('.feature-title');
    var saving = root.querySelector('[data-pl-saving]');

    function show(index) {
      current = (index + tiles.length) % tiles.length;
      var tile = tiles[current];
      tiles.forEach(function (t, i) {
        t.classList.toggle('is-featured', i === current);
        t.setAttribute('aria-pressed', i === current ? 'true' : 'false');
      });
      setText(root, 'notes', tile.dataset.notes || '');
      setText(root, 'name', tile.dataset.name || '');
      setText(root, 'index', String(current + 1));
      setText(root, 'retail', tile.dataset.retail || '');
      setText(root, 'member', tile.dataset.member || '');
      setText(root, 'save', tile.dataset.save || '');
      if (saving) saving.hidden = !tile.dataset.member;
      if (title) {
        // Replay Lovable's title-in animation
        title.style.animation = 'none';
        void title.offsetWidth;
        title.style.animation = '';
      }
    }

    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () { show(i); });
    });
    var prev = root.querySelector('[data-pl-prev]');
    var next = root.querySelector('[data-pl-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  }

  // Process tabs (pl-coffee-grid)
  function initFilter(root) {
    var tabs = root.querySelectorAll('.filter-tabs [data-value]');
    var cards = root.querySelectorAll('[data-category]');
    var count = root.querySelector('[data-pl-count]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var value = tab.dataset.value;
        var shown = 0;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('filter-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          var match = !value || card.dataset.category === value;
          card.hidden = !match;
          if (match) shown++;
        });
        if (count) count.textContent = shown;
      });
    });
  }

  // Coffee details dialogs
  function initDialogs() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-pl-open]');
      if (opener) {
        var dialog = document.getElementById(opener.dataset.plOpen);
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          return;
        }
      }
      if (event.target.closest('[data-pl-close]')) {
        event.target.closest('dialog').close();
        return;
      }
      // Click on the backdrop closes the dialog
      if (event.target.matches('dialog.coffee-dialog')) event.target.close();
    });
  }

  // Coffee choice (pre-launch mode): remembered for the waitlist
  function renderChoice(choice) {
    if (!choice) return;
    document.querySelectorAll('[data-pl-selection]').forEach(function (box) {
      box.hidden = false;
      box.querySelector('[data-pl-selection-name]').textContent = choice.name;
      box.querySelector('[data-pl-selection-grind]').textContent = choice.grind;
    });
    document.querySelectorAll('[data-pl-choice-note]').forEach(function (note) {
      note.hidden = false;
      note.textContent = 'Your coffee pick: ' + choice.name;
    });
    document.querySelectorAll('[data-pl-choose-label]').forEach(function (button) {
      var text = button.querySelector('[data-pl-choose-text]');
      if (!text.dataset.label) text.dataset.label = text.textContent;
      text.textContent = button.dataset.plChooseLabel === choice.name ? 'Selected' : text.dataset.label;
    });
  }

  function initChoice() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pl-choose]');
      if (!button) return;
      var dialog = button.closest('dialog');
      var grind = dialog && dialog.querySelector('[data-pl-grind]');
      var choice = { name: button.dataset.plChoose, grind: grind ? grind.value : '' };
      store('set', CHOICE_KEY, choice);
      renderChoice(choice);
      if (dialog) dialog.close();
    });
    renderChoice(store('get', CHOICE_KEY));
  }

  // Waitlist (pl-waitlist): home/business tag, and the email carried into the deposit checkout
  function initWaitlist(root) {
    var tags = root.querySelector('[data-pl-tags]');
    var types = root.querySelectorAll('[data-pl-type]');
    types.forEach(function (button) {
      button.addEventListener('click', function () {
        types.forEach(function (b) {
          var active = b === button;
          b.classList.toggle('toggle-selected', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (tags) tags.value = 'waitlist,' + button.dataset.plType;
      });
    });

    var form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var email = form.querySelector('[name="contact[email]"]');
        if (email && email.value) store('set', EMAIL_KEY, email.value.trim());
      });
    }

    var email = store('get', EMAIL_KEY);
    root.querySelectorAll('[data-pl-deposit-link]').forEach(function (link) {
      var address = email;
      var input = form && form.querySelector('[name="contact[email]"]');
      if (input) {
        // Before signing up, use whatever is typed in the form
        link.addEventListener('click', function () {
          if (input.value) link.href = withEmail(link.getAttribute('href'), input.value.trim());
        });
      }
      if (address) link.href = withEmail(link.getAttribute('href'), address);
      // After a successful signup, go straight to the deposit checkout
      if (link.hasAttribute('data-pl-auto-redirect')) {
        window.setTimeout(function () { window.location.assign(link.href); }, 1200);
      }
    });
  }

  function withEmail(href, email) {
    var base = href.split('?')[0];
    return base + '?checkout[email]=' + encodeURIComponent(email);
  }

  // Smooth scrolling for in-page links inside Perception sections
  function initSmoothScroll() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.pl-section a[href^="#"]');
      if (!link || link.getAttribute('href').length < 2) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    });
  }


  // Member price block (pl-member-price): follow Trade's variant changes
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var whole = amount.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var text = (format || '£{{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + amount.split('.')[1]);
    return text;
  }

  function renderMemberPrice(box, prices) {
    if (!prices || prices.member === null || prices.member === undefined) {
      box.hidden = true;
      return;
    }
    var format = box.dataset.format;
    var member = formatMoney(prices.member, format);
    var retail = formatMoney(prices.price, format);
    var saving = formatMoney(prices.price - prices.member, format);
    box.hidden = false;
    box.textContent = '';
    if (box.dataset.member === 'true') {
      var s = document.createElement('s');
      s.textContent = retail;
      var strong = document.createElement('strong');
      strong.textContent = member;
      var label = document.createElement('span');
      label.textContent = 'Your member price';
      box.append(s, ' ', strong, ' ', label);
    } else {
      var price = document.createElement('strong');
      price.textContent = member;
      var link = document.createElement('a');
      link.href = box.dataset.join;
      link.textContent = 'Join';
      box.append('Members pay ', price, ' · save ' + saving + ' · ', link);
    }
  }

  function initMemberPrice() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      document.querySelectorAll('[data-pl-member-price]').forEach(function (box) {
        var json = box.parentElement.querySelector('[data-pl-member-prices]');
        if (!json) return;
        var prices;
        try {
          prices = JSON.parse(json.textContent)[String(variant.id)];
        } catch (e) {
          return;
        }
        renderMemberPrice(box, prices);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-pl-featured]').forEach(initFeatured);
    document.querySelectorAll('[data-pl-filter]').forEach(initFilter);
    document.querySelectorAll('[data-pl-waitlist]').forEach(initWaitlist);
    initDialogs();
    initChoice();
    initSmoothScroll();
    initMemberPrice();
  }

  init();

  // Re-run for sections added or changed in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-pl-featured]').forEach(initFeatured);
    event.target.querySelectorAll('[data-pl-filter]').forEach(initFilter);
    event.target.querySelectorAll('[data-pl-waitlist]').forEach(initWaitlist);
    renderChoice(store('get', CHOICE_KEY));
  });
})();
